import type {
  NormalizedDifficulty,
  Platform,
  SessionKind,
  TopicCategory,
  TopicStatus,
} from './types/enums';

/**
 * Монгол хэл дээрх интерфейсийн шошгууд.
 *
 * Дүрэм: алгоритмын онолын нэр томъёо (Dynamic Programming, Segment Tree,
 * Fenwick Tree …), платформын нэр (Codeforces, AtCoder, LeetCode) болон
 * програмчлалын хэлний нэр англиар хэвээр үлдэнэ. Бусад бүх интерфейсийн
 * текстийг энд төвлөрүүлж, web болон mobile хоёр ижил үг хэрэглэнэ.
 *
 * Өгөгдлийн сан болон API дээрх enum-ийн утга (`MASTERED`, `HARD` …) огт
 * өөрчлөгдөөгүй — эдгээр нь зөвхөн дэлгэцэнд харуулах нэр.
 */

export const TOPIC_STATUS_LABELS: Record<TopicStatus, string> = {
  NOT_STARTED: 'Эхлээгүй',
  LEARNING: 'Сурч байна',
  PRACTICING: 'Дасгал хийж байна',
  MASTERED: 'Эзэмшсэн',
};

export const DIFFICULTY_LABELS: Record<NormalizedDifficulty, string> = {
  EASY: 'Хялбар',
  MEDIUM: 'Дунд',
  HARD: 'Хүнд',
  EXPERT: 'Онц хүнд',
};

export const SESSION_KIND_LABELS: Record<SessionKind, string> = {
  SOLVING: 'Бодолт',
  STUDYING: 'Судалгаа',
  REVIEW: 'Давталт',
};

export const CATEGORY_LABELS_MN: Record<TopicCategory, string> = {
  BEGINNER: 'Анхан шат',
  INTERMEDIATE: 'Дунд шат',
  ADVANCED: 'Ахисан шат',
  EXPERT: 'Мастер шат',
};

/** Платформын нэрс нь өөрийн нэр тул орчуулагдахгүй. */
export const PLATFORM_LABELS: Record<Platform, string> = {
  CODEFORCES: 'Codeforces',
  ATCODER: 'AtCoder',
  LEETCODE: 'LeetCode',
  OTHER: 'Бусад',
};
